import React, { Component } from "react";

class Text extends Component {
  render() {
    const { description } = this.props;
    return (
      <div className="container Text">
        <div className="row">
          <div className="col-sm-12 Description">{description}</div>
        </div>
      </div>
    );
  } 
}

export default Text;



// WEBPACK FOOTER //
// ./src/components/Text.js